var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "width": "900"
    },
    model: {
      value: _vm.openModal,
      callback: function ($$v) {
        _vm.openModal = $$v;
      },
      expression: "openModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('checkout')) + " ")]), _c('v-spacer'), _vm.step === 0 && !_vm.hasPaidPlan && _vm.firstPaymentSubstep === 'billing' && !_vm.error && !_vm.loading ? _c('v-btn', {
    staticClass: "header-cancel",
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.firstPaymentSubstep = 'method';
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('cancel')) + " ")]) : _vm._e()], 1), _vm.profileDowngrade ? _c('v-card-text', [_c('div', {
    staticClass: "upgrade-confirmation"
  })]) : _c('v-card-text', [_vm.step === 0 && !_vm.error && !_vm.hasPaidPlan && _vm.firstPaymentSubstep === 'method' ? _c('div', {
    staticClass: "payment-method-selection"
  }, [_c('div', {
    staticClass: "payment-selection-wrapper text-center"
  }, [_c('h3', {
    staticClass: "my-4"
  }, [_vm._v(_vm._s(_vm.$t('please_select_payment_method')))]), _c('div', {
    staticClass: "button-container"
  }, [_c('v-btn', {
    class: {
      'selected-btn': _vm.paymentMethod === 'online'
    },
    attrs: {
      "color": "primary",
      "outlined": _vm.paymentMethod !== 'online'
    },
    on: {
      "click": function ($event) {
        _vm.paymentMethod = 'online';
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('pay_online')) + " ")]), _c('span', {
    staticClass: "mx-3"
  }, [_vm._v(_vm._s(_vm.$t('or')))]), _c('v-btn', {
    class: {
      'selected-btn': _vm.paymentMethod === 'wire'
    },
    attrs: {
      "disabled": !_vm.isYearlyPayment,
      "color": "primary",
      "outlined": _vm.paymentMethod !== 'wire'
    },
    on: {
      "click": function ($event) {
        _vm.paymentMethod = 'wire';
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('wire_transfer')) + " ")])], 1), !_vm.isYearlyPayment ? _c('div', {
    staticClass: "mt-3"
  }, [_vm._v(" " + _vm._s(_vm.$t('wire_transfer_only_available_for_yearly_payments')) + " ")]) : _vm._e()])]) : _vm.step === 0 && !_vm.error && !_vm.hasPaidPlan && _vm.firstPaymentSubstep === 'billing' ? _c('div', {
    staticClass: "billing-info-step"
  }, [_c('div', {
    staticClass: "billing-info-header"
  }, [_c('div', {
    staticClass: "billing-info-title"
  }, [_vm._v(_vm._s(_vm.$t('checkout_view.get_invoice_title')))]), _c('div', {
    staticClass: "billing-info-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('checkout_view.get_invoice_subtitle')))])]), _c('billing-customer', {
    ref: "billing-customer-form",
    attrs: {
      "customer": _vm.customer
    }
  }), _c('billing-business', {
    ref: "billing-business-form",
    attrs: {
      "country": _vm.prefillAddress.country_code || '',
      "business": _vm.prefillBusiness
    }
  }), _c('h3', {
    staticClass: "address-heading"
  }, [_vm._v(_vm._s(_vm.$t('address')))]), _c('billing-address', {
    ref: "billing-address-form",
    attrs: {
      "is-checkout": "",
      "address": _vm.prefillAddress
    }
  }), _vm.paymentMethod === 'wire' ? [_c('h3', {
    staticClass: "address-heading"
  }, [_vm._v(_vm._s(_vm.$t('checkout_view.discount_heading')))]), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('checkout_view.discount_code'),
      "small": "",
      "dense": "",
      "outlined": "",
      "error-messages": _vm.couponErrors
    },
    on: {
      "input": function ($event) {
        _vm.couponErrors = [];
      }
    },
    model: {
      value: _vm.couponCode,
      callback: function ($$v) {
        _vm.couponCode = $$v;
      },
      expression: "couponCode"
    }
  })] : _vm._e(), _c('div', {
    staticClass: "billing-info-primary-action"
  }, [_c('v-btn', {
    staticClass: "raised",
    attrs: {
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function ($event) {
        return _vm.saveAndCheckout();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('checkout_view.save_and_checkout')) + " ")])], 1), _vm.paymentMethod === 'online' ? [_c('div', {
    staticClass: "billing-info-divider"
  }, [_c('span', {
    staticClass: "divider-line"
  }), _c('span', {
    staticClass: "divider-label"
  }, [_vm._v(_vm._s(_vm.$t('or')))]), _c('span', {
    staticClass: "divider-line"
  })]), _c('div', {
    staticClass: "skip-invoice-section"
  }, [_c('div', {
    staticClass: "skip-invoice-text"
  }, [_c('div', {
    staticClass: "skip-invoice-title"
  }, [_vm._v(_vm._s(_vm.$t('checkout_view.no_invoice_needed_title')))]), _c('div', {
    staticClass: "skip-invoice-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('checkout_view.no_invoice_needed_subtitle')))])]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": "",
      "disabled": _vm.loading
    },
    on: {
      "click": function ($event) {
        return _vm.skipInvoiceAndCheckout();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('checkout')) + " ")])], 1)] : _vm._e()], 2) : _vm._e(), _vm.step == 1 ? _c('div', {
    staticClass: "upgrade-confirmation"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_vm.isPaddleCheckoutOpen ? _c('div', {
    staticClass: "ma-auto text-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "50",
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _c('div', [_vm._v(" " + _vm._s(_vm.$t('proceed_to_checkout')) + " ")])])]) : _vm._e(), _vm.step == 2 && !_vm.checkoutError ? _c('div', {
    staticClass: "success-ctn pt-5"
  }, [_c('success-icon'), _c('v-col', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_vm.paymentMethod === 'online' ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('payment_processed_successfully'))
    }
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('wire_transfer_successfull_check_email'))
    }
  })])], 1) : _vm._e(), _vm.checkoutError ? _c('div', {
    staticClass: "success-ctn"
  }, [_c('error-icon'), _c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.$t('payment_error')) + " "), _c('br')]), _c('p', {
    staticClass: "error-message"
  }, [_vm._v(" " + _vm._s(_vm.checkoutError && _vm.checkoutError !== null ? `(${_vm.checkoutError})` : '') + " ")]), _c('p', [_vm._v(" " + _vm._s(_vm.$t('contact_support_for_help')) + " ")])])], 1) : _vm._e()]), _c('v-card-actions', [_c('v-spacer'), !(_vm.step === 0 && !_vm.hasPaidPlan && _vm.firstPaymentSubstep === 'billing' && !_vm.error && !_vm.loading) ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.close();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('close')) + " ")]) : _vm._e(), _vm.step === 1 ? _c('div', [_c('v-btn', {
    staticClass: "raised ml-5",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.confirm();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('checkout')) + " ")])], 1) : !_vm.paddleLoaded && !_vm.profileDowngrade && _vm.step !== 2 && !_vm.loading && !(_vm.step === 0 && !_vm.hasPaidPlan && _vm.firstPaymentSubstep === 'billing') ? _c('v-btn', {
    staticClass: "ml-5 raised",
    attrs: {
      "color": "primary",
      "disabled": _vm.step === 0 && !_vm.hasPaidPlan && _vm.firstPaymentSubstep === 'method' && _vm.paymentMethod === null,
      "loading": _vm.loading
    },
    on: {
      "click": function ($event) {
        return _vm.handlePrimaryAction();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.primaryActionLabel) + " ")]) : _vm._e()], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }